!function(){"use strict";
  const selectors = {
    productPage: '.product__page',
    formWrapper: '[data-form-wrapper]',
    stickyHeader: '[data-header-sticky]',
    productMediaList: '[data-product-media-list]',
    productImages: 'product-images',
    stickyImages: 'product-images.is-sticky'
  };
  
  const classes = {
    isSticky: 'is-sticky'
  };

  customElements.get("product-sticky") || customElements.define("product-sticky", class extends HTMLElement {
    constructor() {
      super();
      this.formWrapper = this.querySelector(selectors.formWrapper);
      this.imagesWrapper = this.querySelector(selectors.productImages);
      this.stickyImagesWrapper = this.querySelector(selectors.stickyImages);
      this.stickyElement = null; // Will be determined dynamically
      this.staticElement = null; // The non-sticky element
      
      this.stickyScrollTop = 0;
      this.scrollLastPosition = 0;
      this.stickyDefaultTop = 0;
      this.currentPoint = 0;
      this.defaultTopBottomSpacings = 30;
      this.scrollTopPosition = window.scrollY;
      this.scrollDirectionDown = true;
      this.requestAnimationSticky = null;
      this.stickyFormLoad = true;
      this.stickyFormLastHeight = null;
      this.onChangeCounter = 0;
      
      // Settings
      this.stickyFormEnabled = this.getAttribute('data-sticky-enabled') === 'true';
      this.stickyImagesEnabled = this.getAttribute('data-sticky-images-enabled') === 'true';
      
      this.scrollEvent = (e) => this.scrollEvents(e);
      this.resizeEvent = (e) => this.resizeEvents(e);
      this.stickyFormEvent = (e) => this.stickyFormEvents(e);
    }

    connectedCallback() {
      this.stickyScrollCheck();
      this.setSingleImageThumbnailHeight();
      document.addEventListener("theme:resize", this.resizeEvent);
      
      if (theme.variables.productPageSticky) {
        this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition());
        if (this.stickyElement) {
          this.stickyElement.addEventListener("theme:form:sticky", this.stickyFormEvent);
        }
        document.addEventListener("theme:scroll", this.scrollEvent);
      }
    }

    stickyFormEvents(e) {
      this.removeAnimationFrameSticky();
      this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e));
    }

    scrollEvents(e) {
      this.scrollTopPosition = e.detail.position;
      this.scrollDirectionDown = e.detail.down;
      
      if (!this.requestAnimationSticky) {
        this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition());
      }
    }

    resizeEvents(e) {
      this.stickyScrollCheck();
      document.removeEventListener("theme:scroll", this.scrollEvent);
      if (this.stickyElement) {
        this.stickyElement.removeEventListener("theme:form:sticky", this.stickyFormEvent);
      }
    }

    stickyScrollCheck() {
      const productPageElement = this.querySelector(`${selectors.productPage} ${selectors.formWrapper}`);
      
      if (productPageElement) {
        if (window.theme.isMobile()) {
          theme.variables.productPageSticky = false;
          // Classes are managed by Liquid, no need to remove them here
        } else {
          const formWrapper = this.formWrapper;
          const imagesWrapper = this.imagesWrapper; // This includes both images AND videos
          
          if (!formWrapper || !imagesWrapper) return;
          
          const formHeight = formWrapper.offsetHeight;
          const imagesHeight = imagesWrapper.offsetHeight; // Full height including videos
          
          console.log('Form height:', formHeight, 'Images height (including videos):', imagesHeight);
          console.log('Sticky form enabled:', this.stickyFormEnabled, 'Sticky images enabled:', this.stickyImagesEnabled);
          
          // Determine which element should be sticky based on settings and heights
          if (this.stickyFormEnabled && formHeight < imagesHeight) {
            // Form is shorter - make form sticky
            theme.variables.productPageSticky = true;
            this.stickyElement = this.querySelector(`${selectors.productPage} ${selectors.formWrapper}`);
            this.staticElement = imagesWrapper;
            console.log('Making form sticky');
          } else if (this.stickyImagesEnabled && this.stickyImagesWrapper && imagesHeight < formHeight) {
            // Images are shorter and have is-sticky class - make images sticky
            theme.variables.productPageSticky = true;
            this.stickyElement = this.stickyImagesWrapper;
            this.staticElement = formWrapper;
            console.log('Making images sticky');
          } else {
            // No sticky behavior
            theme.variables.productPageSticky = false;
            this.stickyElement = null;
            console.log('No sticky behavior - Form:', formHeight, 'Images (including videos):', imagesHeight);
          }
        }
      }
    }

    calculateStickyPosition(e = null) {
      if (!this.stickyElement || document.documentElement.hasAttribute("data-scroll-locked")) {
        this.removeAnimationFrameSticky();
        return;
      }

      const isFormEvent = Boolean(e && e.detail);
      const isAccordionEvent = Boolean(isFormEvent && e.detail.element && e.detail.element === "accordion");
      const stickyElementHeight = this.stickyElement.offsetHeight;
      const maxStickyTop = window.innerHeight - stickyElementHeight - this.defaultTopBottomSpacings;
      const scrollDistance = Math.abs(this.scrollTopPosition - this.scrollLastPosition);

      if (this.scrollDirectionDown) {
        this.stickyScrollTop -= scrollDistance;
      } else {
        this.stickyScrollTop += scrollDistance;
      }

      if (this.stickyFormLoad) {
        if (document.querySelector(selectors.stickyHeader)) {
          const { headerHeight } = window.theme.readHeights();
          this.stickyDefaultTop = headerHeight;
        } else {
          this.stickyDefaultTop = this.defaultTopBottomSpacings;
        }
        this.stickyScrollTop = this.stickyDefaultTop;
      }

      this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, maxStickyTop), this.stickyDefaultTop);

      const stickyTopDifference = this.stickyScrollTop - this.currentPoint;
      this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + stickyTopDifference * 0.5;

      this.stickyElement.style.setProperty("--sticky-top", `${this.currentPoint}px`);

      this.scrollLastPosition = this.scrollTopPosition;
      this.stickyFormLoad = false;

      const shouldContinueAnimation = (isAccordionEvent && this.onChangeCounter <= 10) || 
                                     (isAccordionEvent && this.stickyFormLastHeight !== stickyElementHeight) || 
                                     (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky);

      if (shouldContinueAnimation) {
        if (isAccordionEvent) {
          this.onChangeCounter += 1;
        }
        if (isAccordionEvent && this.stickyFormLastHeight !== stickyElementHeight) {
          this.onChangeCounter = 11;
        }
        this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e));
      } else if (this.requestAnimationSticky) {
        this.removeAnimationFrameSticky();
      }

      this.stickyFormLastHeight = stickyElementHeight;
    }

    removeAnimationFrameSticky() {
      if (this.requestAnimationSticky) {
        cancelAnimationFrame(this.requestAnimationSticky);
        this.requestAnimationSticky = null;
        this.onChangeCounter = 0;
      }
    }

    setSingleImageThumbnailHeight() {
      // Fix for single image thumbnail height
      const productImages = this.querySelector('product-images');
      const thumbsContainer = this.querySelector('product-thumbs');
      
      if (productImages && thumbsContainer) {
        // Check if there's only one media item (single image/video)
        const mediaItems = thumbsContainer.querySelectorAll('.product__thumb');
        const isSingleMedia = mediaItems.length === 1;
        
        if (isSingleMedia) {
          // Set height after images load
          const setThumbnailHeight = () => {
            const activeMedia = productImages.querySelector('.product__slide img, [data-media-id] img');
            if (activeMedia) {
              const mediaHeight = activeMedia.offsetHeight;
              console.log('Single media height detected:', mediaHeight); // Debug log
              if (mediaHeight > 0) {
                productImages.style.setProperty('--height', mediaHeight + 'px');
                console.log('Set --height to:', mediaHeight + 'px'); // Debug log
              }
            }
          };
          
          // Try immediately
          setThumbnailHeight();
          
          // Try after a short delay
          setTimeout(setThumbnailHeight, 200);
          
          // Try after all images load
          const images = productImages.querySelectorAll('img');
          let loadedImages = 0;
          
          images.forEach(img => {
            if (img.complete) {
              loadedImages++;
              if (loadedImages === images.length) {
                setTimeout(setThumbnailHeight, 50);
              }
            } else {
              img.addEventListener('load', () => {
                loadedImages++;
                if (loadedImages === images.length) {
                  setTimeout(setThumbnailHeight, 50);
                }
              });
            }
          });
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.resizeEvent);
      if (theme.variables.productPageSticky) {
        document.removeEventListener("theme:scroll", this.scrollEvent);
      }
    }
  });
}();
